<div class="box">
    <div>
        <h1>Listado de entidades</h1>
    </div>

    <div class="p-d-flex p-flex-wrap p-jc-center p-ai-center p-p-2">
        <div class="p-p-2">
            <h2>Si deseas agregar una nueva entidad</h2>
        </div>
        <div class="p-p-2">
            <button pButton type="button" label="Haz click aquí" (click)="irEntidades()"></button>

        </div>
    </div>

    <div *ngIf="isLoading" class="loading-container">
        <i class="pi pi-spin pi-spinner pi-spinner"></i>
    </div>
    <div *ngIf="!isLoading">
        <p-table [value]="data" [scrollable]="true" [columns]="data" scrollHeight="500px">
            <ng-template pTemplate="header" let-columns>
                <tr>
                    <th class="p-text-bold">Nombre Entidad</th>
                    <th class="p-text-bold">Dirección</th>
                    <th class="p-text-center p-text-bold">Correo</th>
                    <th class="p-text-center p-text-bold">Acciones</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-columns="columns">
                <tr>
                    <td>{{ rowData.nombre_entidades }}</td>
                    <td>{{ rowData.direccion_residencia }}</td>
                    <td class="p-text-center">{{ rowData.emails_contacto }}</td>
                    <td class=" p-d-flex p-flex-wrap p-ai-center p-as-center p-jc-center">
                        <div class="p-p-1">
                            <button pButton type="button" label="Asignar" (click)="irAsignar()"></button>
                        </div>
                        <div class="p-p-1">
                            <button pButton type="button" label="Usuarios" class="p-button-success"
                                (click)="irUsuarios()"></button>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>